import React from 'react';

import EditProfileFormSection from './EditProfileFormSection';
import EditProfileFieldsContact, {
    editProfileContactValidationSchema,
} from '../../../_molecules/EditProfileFieldsContact';

import EditProfileFieldsSocial, {
    editProfileSocialValidationSchema,
} from '../../../_molecules/EditProfileFieldsSocial';

import EditProfileFormAddresses from '../../../_molecules/EditProfileFormAddresses';
import { DividerLightGreyStyled, Instructions } from '@styled';
import editProfileAddressValidationSchema from '../../../_molecules/EditProfileFormAddresses/editProfileAddressValidationSchema';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';

const validationSchema = {
    ...editProfileContactValidationSchema,
    ...editProfileAddressValidationSchema,
    ...editProfileSocialValidationSchema,
};

const EditProfileContactPage = () => (
    <ErrorHandler>
        <TrackPageView>
            <EditProfileFormSection
                validationSchema={validationSchema}
                pageTitleSub="Contact Information"
                prevNavLink="/my-icsc/account/edit-profile/basic"
                prevNavLabel="Basic Information"
                nextNavLink="/my-icsc/account/edit-profile/education"
                nextNavLabel="Education & Employment"
            >
                <DividerLightGreyStyled className="mt-3 mb-4" />
                <h4 className="mb-0">Contact Information</h4>
                <Instructions>
                    Make sure your contact information is up to date in order to recieve renewal notices, event related
                    materials, and more.
                </Instructions>
                <h5 className="mb-4 mt-3">Email, Phone, and Fax</h5>
                <EditProfileFieldsContact />

                <EditProfileFormAddresses />
                <DividerLightGreyStyled className="mt-5 mb-4" />
                <h4 className="mb-0">Social Media</h4>
                <Instructions>Make it easy to connect with members by linking your social accounts.</Instructions>
                <EditProfileFieldsSocial />
            </EditProfileFormSection>
        </TrackPageView>
    </ErrorHandler>
);

export default EditProfileContactPage;
